import React from 'react';
import AppPage from './AppPage';
import './App.css';
import content from './content/shell.json';

const ShellDownloadPage = () => <AppPage content={content} />;

export default ShellDownloadPage;
